var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-modal',{attrs:{"id":_vm.id,"buttons":_vm.dialogButtons}},[_c('div',{staticClass:"text-center font-size-16"},[_vm._v("連携を解除してもよろしいですか?")])])}
var staticRenderFns = []

export { render, staticRenderFns }